import { DatePipe } from '@angular/common';
import { Component, effect, output, signal } from '@angular/core';

import { TranslatePipe } from '@camelot/translation';
import { ButtonToolComponent } from '@camelot/ui';

import { CamTranslationCalendar } from '../../../translation.service';
import { CalendarModeType } from '../../../types/calendar';
import { AbstractCalendarComponent } from '../../abstract-calendar.component';

@Component({
  selector: 'cam-calendar-header',
  imports: [ButtonToolComponent, DatePipe, TranslatePipe],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class CamCalendarHeaderComponent extends AbstractCalendarComponent {
  mapToggle = output<boolean>();

  readonly mapOpened = signal(false);

  constructor() {
    super();
    CamTranslationCalendar.getInstance();
    effect(() => {
      this.mapToggle.emit(this.mapOpened());
    });
  }

  public changeMode(mode: CalendarModeType) {
    this._calendar.setMode(mode);
  }

  public mode(): CalendarModeType | null {
    return this._calendar.api?.currentMode() ?? null;
  }

  public date() {
    const activeView = this._calendar.api?.getActiveView();
    if (!activeView) {
      return null;
    }
    return {
      start: activeView.startDate,
      end: activeView.endDate,
    };
  }

  public goToToday() {
    this._calendar.api?.shiftToNow();
  }

  public goToNext() {
    this._calendar.api?.shiftNext();
  }

  public goToPrevious() {
    this._calendar.api?.shiftPrevious();
  }

  public toggleMap() {
    this.mapOpened.set(!this.mapOpened());
  }
}
